'use strict';

var domCache = require('dom-cache');

var dom;
var floatStartY;
var isFloating = false;
var numTimesScrolled = 0;

var addEventHandlers = function() {

	domCache.window.on('scroll', onWindowScroll);
	domCache.document.on('ready', onDomReady);
	dom.productNav.on('scroll', onProductNavScroll);

};

var onDomReady = function() {

	if (!dom.selectedNavItem.length) {
		return;
	}

	var baseOffset = parseInt(dom.selectedNavItem.offset().left, 10);
	var halfWindowWidth = domCache.window.width() / 2;
	var halfItemWidth = dom.selectedNavItem.width() / 2;
	var offset = baseOffset - (halfWindowWidth - halfItemWidth);

	dom.productNav.scrollLeft(offset);

};

var onProductNavScroll = function() {

	numTimesScrolled++;

	if (numTimesScrolled > 1) {

		dom.productNavContainer.addClass('product-nav-container--has-scrolled');

	}

};

var onWindowScroll = function() {

	floatStartY = parseInt(dom.productNavContainer.attr('data-float-start'), 10);

	if (!isFloating && window.pageYOffset > floatStartY) {

		dom.productNavContainer.addClass('product-nav__is-floating');

		isFloating = true;

	} else if (isFloating && window.pageYOffset < floatStartY) {

		dom.productNavContainer.removeClass('product-nav__is-floating');

		isFloating = false;

	}

};

var setupDom = function() {

	dom = {};
	dom.productNavContainer = $('.product-nav-container');
	dom.productNav = dom.productNavContainer.find('.product-nav');
	dom.selectedNavItem = dom.productNavContainer.find('.location-matcher--is-selected');

};

var init = function() {

	setupDom();

	addEventHandlers();

};

module.exports = {
	init: init
};